import React, { createContext, useContext, useEffect, useState } from "react";
import api from "pages/api/api";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [authenticated, setAuthenticated] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  // ---- helpers de permissões ----
  const temFuncao = (nomeFuncao) => {
    return !!userData?.funcoes?.includes?.(nomeFuncao);
  };

  // tipo = "r" | "w" | "u" | "d"
  const temPermissao = (acesso, tipo) => {
    if (!acesso || !tipo) return false;
    const p = userData?.permissoes?.find?.(
      (x) => x?.acesso?.toLowerCase?.() === acesso.toLowerCase()
    );
    return !!(p && p[tipo.toLowerCase?.()] === 1);
  };

  // ---- carregar sessão do storage ----
  useEffect(() => {
    try {
      const storedUser = localStorage.getItem("userData");
      const token = localStorage.getItem("token");
      if (storedUser && token) {
        const userObj = JSON.parse(storedUser);
        if (userObj?.id) {
          setUserData(userObj);
          setAuthenticated(true);
        } else {
          localStorage.removeItem("userData");
          localStorage.removeItem("token");
        }
      }
    } catch (e) {
      console.error("Erro ao ler sessão:", e);
      localStorage.removeItem("userData");
      localStorage.removeItem("token");
    } finally {
      setLoading(false);
    }
  }, []);

  // ---- ações ----
  function login(user, token) {
    if (!user || !token) return;
    try {
      localStorage.setItem("userData", JSON.stringify(user));
      localStorage.setItem("token", token);
      setUserData(user);
      setAuthenticated(true);
    } catch (e) {
      console.error("Erro ao guardar sessão:", e);
    }
  }

  async function logout() {
    try {
      await api.post("Auth/Logout", {}); // opcional
    } catch {
      /* ignora */
    }
    localStorage.removeItem("userData");
    localStorage.removeItem("token");
    setUserData(null);
    setAuthenticated(false);
  }

  const value = {
    authenticated,
    isAuthenticated: authenticated, // alias para compatibilidade
    userData,
    loading,
    login,
    logout,
    temFuncao,
    temPermissao,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
